<div id="claim-and-clean-keywords-bar">
  <div id="claim-and-clean-keywords-container">
    <p>Keywords</p>
    <mat-form-field appearance="fill">
      <div class="mat-chip-list-wrapper">
        <mat-chip-grid #claimCleanKeywordsChipList [formControl]="claimCleanCtrl">
          @for (keyword of (claimCleanKeywords || []); track keyword) {
            <mat-chip-row
              [ngClass]="{'exclusion-keyword': keyword.startsWith('-')}"
              (removed)="removeClaimCleanKeyword(keyword)">
              {{keyword}}
              <mat-icon matChipRemove svgIcon="close"></mat-icon>
            </mat-chip-row>
          }
          <input matInput appGxInput
            [matChipInputFor]="claimCleanKeywordsChipList"
            [matChipInputSeparatorKeyCodes]="claimCleanKeywordSeparators"
            (matChipInputTokenEnd)="addClaimCleanKeyword($event)"
            (paste)="pasteClaimCleanKeywords($event)">
          </mat-chip-grid>
        </div>
      </mat-form-field>
    </div>
  </div>
